/**
 * Converte handle ou URL parcial do Instagram em URL absoluta do perfil.
 * Sem isso, um valor só com username vira href relativo e o React Router devolve 404.
 */
export function normalizeInstagramProfileUrl(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  let s = raw.trim();
  if (!s) return null;

  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s);
      const host = u.hostname.replace(/^www\./i, "").toLowerCase();
      if (host !== "instagram.com" && host !== "instagr.am") {
        return s;
      }
      return u.href;
    } catch {
      return null;
    }
  }

  s = s.replace(/^@+/, "");
  const lower = s.toLowerCase();
  const marker = "instagram.com/";
  const idx = lower.indexOf(marker);
  if (idx !== -1) {
    s = s.slice(idx + marker.length).split("/")[0].split("?")[0];
  }
  if (!s) return null;
  return `https://www.instagram.com/${s}`;
}
